export const REQUEST_PAYMENT_REQUESTS = 'REQUEST_PAYMENT_REQUESTS';
export const RECEIVE_PAYMENT_REQUESTS = 'RECEIVE_PAYMENT_REQUESTS';
export const FAILURE_PAYMENT_REQUESTS = 'FAILURE_PAYMENT_REQUESTS';



// WEBPACK FOOTER //
// ./src/services/account/paymentrequest/ongoing/constants.js